import React from 'react';

import Visibility from 'material-ui/svg-icons/action/visibility';
import VisibilityOff from 'material-ui/svg-icons/action/visibility-off';
import DoneIcon from 'material-ui/svg-icons/action/done';

import { TextInput, MultipleChoicesFromDataInput } from 'components/input';
import { SimpleForm } from 'components/form';

import Edit from 'components/detail/Edit';

import {
    groupEditBackendPath
} from './urls'


const styles = {
    permissionChoices: {
        marginBottom: 24,
    }
};

export const GroupEdit = (props) => (
    <Edit editBackendPath={groupEditBackendPath} {...props}>
        <SimpleForm submitButtonIcon={<DoneIcon/>} submitButtonLabel="Confirm">
            <TextInput label="Name" source="name"/>
            <MultipleChoicesFromDataInput
                label="Permissions"
                source="perm_ids"
                choiceSource="perm_choices"
                options={{style: styles.permissionChoices, checkedIcon: <Visibility />, uncheckedIcon: <VisibilityOff />}}
            />
        </SimpleForm>
    </Edit>
);


// WEBPACK FOOTER //
// ./src/routes/user/GroupEdit.js